module.exports = __webpack_public_path__ + "static/media/image-excel.f2eb4184.svg";